"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function Hero() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section ref={heroRef} className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/hero_productions_office.png)]">
      {}
      <div className="absolute inset-0 bg-dark-background/70" />

      {}
      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
        {}
        <h1 className={`font-display text-5xl font-bold leading-tight text-foreground-dark md:text-6xl lg:text-7xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${heroVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          Empowering Businesses and Creative Ventures
        </h1>

        {}
        <p className={`mt-6 text-lg text-foreground-dark/90 md:text-xl lg:text-2xl transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${heroVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          Professional management, strategic guidance, and film project development to drive clarity, credibility, and forward momentum.
        </p>

        {}
        <div className={`mt-10 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${heroVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover active:bg-primary-active shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:shadow-strong">
            <Link to="/ContactPage">
              Get Started
              <ArrowRight className="size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}